import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { LiveChatFlowInterface, LiveChatFlowStateType, LiveChatWindowStateType } from '@central-products/interface-live-chat-flow';
import { AccountInfoStateType } from '@central-products/interface-account-info';
import { OfferState, State as LivePersonStateType } from '@central-products/liveperson-client';
export var LiveChatFlow = /*#__PURE__*/function (_LiveChatFlowInterfac) {
  _inherits(LiveChatFlow, _LiveChatFlowInterfac);

  var _super = _createSuper(LiveChatFlow);

  function LiveChatFlow(config, deps) {
    var _this;

    _classCallCheck(this, LiveChatFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "deps", void 0);

    _defineProperty(_assertThisInitialized(_this), "stateChangeListener", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      state: LiveChatFlowStateType.STOPPED,
      chatButtonVisible: false,
      windowState: LiveChatWindowStateType.UNKOWN
    });

    _defineProperty(_assertThisInitialized(_this), "handleAccountInfoStateChanged", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var accountId, state, _this$deps$liveperson, clientState;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                accountId = _ref.accountId, state = _ref.state;

                if (!(state === AccountInfoStateType.ACCOUNT_INFO_REQUESTED)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this$deps$liveperson = _this.deps['liveperson-client'].getState(), clientState = _this$deps$liveperson.state;
                return _context.abrupt("return", clientState === LivePersonStateType.NOT_INITIALISED ? _this.initializeClient(accountId) : _this.updateClientIdentity(accountId));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleClientStateChange", function (_ref3) {
      var offers = _ref3.offers,
          windowState = _ref3.windowState,
          chatState = _ref3.chatState;

      _this.setState({
        windowState: windowState,
        conversationState: chatState,
        chatButtonVisible: _this.getChatButtonState(offers)
      });
    });

    _this.config = config;
    _this.deps = deps;
    return _this;
  }

  _createClass(LiveChatFlow, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$this$deps$acco, accountId;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.deps['account-info'].getState();

              case 2:
                _yield$this$deps$acco = _context2.sent;
                accountId = _yield$this$deps$acco.accountId;
                _context2.next = 6;
                return this.sleep(this.config.initDelay || 0);

              case 6:
                _context2.next = 8;
                return this.initializeClient(accountId);

              case 8:
                this.deps['account-info'].onStateChanged(this.handleAccountInfoStateChanged);
                this.deps['liveperson-client'].onStateChange(this.handleClientStateChange);
                this.resolveInitialState(!!this.config.client.autoStart);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state.state !== LiveChatFlowStateType.INITIALIZED)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('[LiveChat Flow] not initialized');

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return this.deps['liveperson-client'].start();

              case 5:
                return _context3.abrupt("return", {
                  error: null
                });

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                return _context3.abrupt("return", {
                  error: _context3.t0
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.state.state !== LiveChatFlowStateType.STARTED)) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('[LiveChat Flow] is not started');

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return this.deps['liveperson-client'].refresh();

              case 5:
                return _context4.abrupt("return", {
                  error: null
                });

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);
                return _context4.abrupt("return", {
                  error: _context4.t0
                });

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", _Object$assign({}, this.state));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(cb) {
      this.stateChangeListener = cb;
    }
  }, {
    key: "getActiveEngagements",
    value: function () {
      var _getActiveEngagements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.deps['liveperson-client'].getActiveEngagements());

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getActiveEngagements() {
        return _getActiveEngagements.apply(this, arguments);
      }

      return getActiveEngagements;
    }()
  }, {
    key: "activateEngagement",
    value: function activateEngagement(payload) {
      this.deps['liveperson-client'].activateEngagement(payload);
    }
  }, {
    key: "setAudiences",
    value: function setAudiences(audiences) {
      return this.deps['liveperson-client'].setAudiences(audiences);
    }
  }, {
    key: "sleep",
    value: function sleep(timeInMs) {
      return new _Promise(function (resolve) {
        return setTimeout(resolve, timeInMs);
      });
    }
  }, {
    key: "resolveInitialState",
    value: function resolveInitialState(started) {
      var state = started ? LiveChatFlowStateType.STARTED : LiveChatFlowStateType.INITIALIZED;
      this.setState({
        state: state
      });
    }
  }, {
    key: "getChatButtonState",
    value: function getChatButtonState(offers) {
      var chatButtonName = this.config.chatButtonName || 'liveChat';

      var button = _Object$values(offers).find(function (_ref4) {
        var name = _ref4.name;
        return chatButtonName === name;
      });

      return !!(button && button.state === OfferState.DISPLAYED);
    }
  }, {
    key: "updateClientIdentity",
    value: function updateClientIdentity(accountId) {
      this.deps['liveperson-client'].setUserID(accountId || undefined);
    }
  }, {
    key: "initializeClient",
    value: function () {
      var _initializeClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(userId) {
        var started;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.deps['liveperson-client'].init({
                  cas: {
                    casUrl: this.config.client.casUrl || this.getDefaultCasUrl(this.config),
                    clientId: this.config.client.clientId || 'LivePersonWH',
                    responseType: this.config.client.authResponseType || 'code',
                    redirectUrl: this.config.client.authRedirectUrl || 'https://liveperson.net/callback'
                  },
                  sdk: {
                    userId: userId || undefined,
                    environment: this.config.client.environment,
                    autoStart: this.config.client.autoStart,
                    syncAudiences: this.config.client.syncAudiences,
                    authFunctionProperty: this.config.client.authFunctionProperty,
                    issuer: this.config.client.issuer // toDo: make sure all possible props are addressed. Undefined for boolean values will not override default value for optional

                  }
                });

              case 2:
                started = typeof this.config.client.autoStart === 'undefined' ? true : !!this.config.client.autoStart;
                this.setState({
                  state: started ? LiveChatFlowStateType.STARTED : LiveChatFlowStateType.INITIALIZED
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function initializeClient(_x2) {
        return _initializeClient.apply(this, arguments);
      }

      return initializeClient;
    }()
  }, {
    key: "getDefaultCasUrl",
    value: function getDefaultCasUrl(_ref5) {
      var jurisdiction = _ref5.jurisdiction,
          environment = _ref5.environment;
      return "https://auth.williamhill".concat(environment === 'prod' ? '' : "-".concat(environment), ".").concat(jurisdiction, "/cas");
    }
  }, {
    key: "setState",
    value: function setState(stateSlice) {
      if (this.hasChanges(stateSlice)) {
        this.state = _Object$assign({}, this.state, stateSlice);
        this.notifyStateChange();
      }
    }
  }, {
    key: "hasChanges",
    value: function hasChanges(stateSlice) {
      var key;

      for (key in stateSlice) {
        if (stateSlice[key] !== this.state[key]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "notifyStateChange",
    value: function notifyStateChange() {
      if (this.stateChangeListener) {
        this.stateChangeListener(_Object$assign({}, this.state));
      }
    }
  }]);

  return LiveChatFlow;
}(LiveChatFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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